import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgpSharedAggregatorComponentRegistryModule } from '@liberty-financial/agp-shared';

import { SparkCoreModule } from '@core/core.module';
import { ReportsModule } from '@features/reports/reports.module';
import { LoadModule } from '@shared/components/load/load.module';
import { OpportunityViewModule } from '@shared/components/opportunity-view/opportunity-view.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { SharedModule } from '@shared/shared.module';

import { AnnouncementListComponent } from './components/announcement-list/announcement-list.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { MpmContactUsComponent } from './components/contact-us/mpm/contact-us.component';
import { NmbContactUsComponent } from './components/contact-us/nmb/contact-us.component';
import { InsightCardComponent } from './components/insight-card/insight-card.component';
import { LeadInsightComponent } from './components/lead/lead-insight/lead-insight.component';
import { LendingActivityComponent } from './components/opportunity/lending-activity/lending-activity.component';
import { LoanInsightComponent } from './components/opportunity/loan-insight/loan-insight.component';
import { OpportunityInsightComponent } from './components/opportunity/opportunity-insight/opportunity-insight.component';
import { OpportunityListComponent } from './components/opportunity/opportunity-list/opportunity-list.component';
import { MpmStoreDetailsComponent } from './components/store/store-details/mpm/store-details.component';
import { NmbStoreDetailsComponent } from './components/store/store-details/nmb/store-details.component';
import { StoreDetailsComponent } from './components/store/store-details/store-details.component';
import { TaskListComponent } from './components/task/task-list/task-list.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './views/dashboard.component';
import { LendingPartnerProgramComponent } from './components/lending-partner-program/lending-partner-program.component';

@NgModule({
  declarations: [
    DashboardComponent,
    AnnouncementListComponent,
    TaskListComponent,
    InsightCardComponent,
    OpportunityInsightComponent,
    LoanInsightComponent,
    LeadInsightComponent,
    ContactUsComponent,
    MpmContactUsComponent,
    OpportunityListComponent,
    LendingActivityComponent,
    StoreDetailsComponent,
    MpmStoreDetailsComponent,
    NmbContactUsComponent,
    NmbStoreDetailsComponent,
    LendingPartnerProgramComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    SharedModule,
    DashboardRoutingModule,
    LoadModule,
    OpportunityViewModule,
    ReportsModule,
    SparkCoreModule,
    AgpSharedAggregatorComponentRegistryModule
  ]
})
export class DashboardModule {}
